export const styles = {
  root: 'absolute bottom-0 left-0 right-0 top-0 cursor-auto justify-center',
  content: 'w-full h-full bg-[rgba(82,100,118,0.85)]',
};
